<template>
  <div>
    <v-card class="ma-2 mt-5">
      <v-data-table :headers="empdata" dense :items="empitems" :search="search">
        <template v-slot:[`item.full_name`]="{ item }">
          <span class="caption">{{ item.full_name }}</span>
        </template>
        <template v-slot:[`item.mobile_no`]="{ item }">
          <span class="caption">{{ item.mobile_no }}</span>
        </template>
        <template v-slot:[`item.created_on`]="{ item }">
          <span class="caption">{{ item.created_on }}</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small @click="viewemp(item)" color="primary">mdi-eye</v-icon>
        </template>
        <template v-slot:top>
          <v-layout row wrap>
            <v-row class="mt-2 mb-2">
              <v-col cols="2" class="ml-5">
                <UploadExcelComponent
                  :on-success="handleSucc"
                  :before-upload="beforeUpload"
                />
                <!-- <v-list-item dense>
                      <v-list-item-title>Upload</v-list-item-title>
                </v-list-item>-->
              </v-col>
              <v-col cols="1" class="ml-4">
                <v-btn
                  fab
                  class="elevation-0"
                  color="primary"
                  small
                  @click="handleUpload"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </v-col>
              <v-spacer />
              <v-col cols="3">
                <v-text-field
                  v-model="search"
                  shaped
                  outlined
                  dense
                  class="mt-n1 ml-n6"
                  color="primary"
                  append-icon="mdi-magnify"
                  label="Search"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-layout>
        </template>
      </v-data-table>
    </v-card>
    <OverleyProccessg :overlay="overlay" />
    <viewemployee ref="viewemployee" />
  </div>
</template>

<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import { apiCall } from "@/Views/APICALL/APIcall.js";
import UploadExcelComponent from "@/Views/UploadExcel/index.vue";
import viewemployee from "@/Views/Employees/viewemployee.vue";
export default {
  components: { viewemployee, UploadExcelComponent, OverleyProccessg },
  data: () => ({
    search: "",
    overlay: false,
    locations: [],
    locationValue: "",
    status: "",
    statuss: ["Active", "Locked", "Closed"],
    empdata: [
      { text: "SL NO", value: "sl_no", width: "1px" },
      {
        text: "NAME",
        value: "full_name",
        width: "1px",
      },
      {
        text: "EMPLOYEE ID",
        value: "empid",
        width: "1px",
      },
      {
        text: "CONTACT NUMBER",
        value: "mobile_no",
        width: "1px",
      },
      {
        text: "ONBOARDED ON",
        value: "created_on",
        width: "1px",
      },
      {
        text: "LOCATION",
        value: "location",
        width: "1px",
      },
      {
        text: "ACTION",
        value: "actions",
        width: "1px",
      },
    ],
    empitems: [],
  }),
  created() {
    this.getEmpDetails();
  },
  methods: {
    beforeUpload(file) {
      //   this.uploadExcel = file;
      console.warn(file);
      return true;
    },
    async handleSucc({ results, header }) {
      console.warn(results);
      console.warn(header);
      this.ExcelDetails = true;
    },
    async getEmpDetails() {
      var inputData = {
        method_name: "ADMINCUST",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "CUSTVIEW",
          search_text: "",
          corp_id: this.$store.getters.get_corpid,
          type: "0",
        },
      };
      var responseData = await apiCall(inputData);
      //console.log("empitemsresponseData", responseData.data.data);
      this.empitems =
        responseData.data.data == null ? [] : responseData.data.data;
    },
    viewemp(item) {
      this.$refs.viewemployee.empdialog = true;
      this.$refs.viewemployee.itemDetails = item;
      // console.log(" this.$refs.viewemployee.itemDetails", this.$refs.viewemployee.itemDetails)

      this.$refs.viewemployee.address = JSON.parse(
        item.address
      ).residential_address;
      var documentlist = {
        document_url: item.documents,
        DocumentName: this.getFileName(item.documents),
        DocumentExt: this.getExtension(item.documents),
      };
      // console.log(documentlist);
      var reportUrllist = {
        report_url: item.report_url,
        reportName: this.getFileName(item.report_url),
        reportExt: this.getExtension(item.report_url),
      };
      this.$refs.viewemployee.documentlist = documentlist;
      this.$refs.viewemployee.reportUrllist = reportUrllist;
      //console.log(reportUrllist);
    },
    getFileName(filename) {
      if (filename != null) {
        var url = filename.split("/");
        var len = url.length;
        const sample = url[len - 1];
        return sample;
      } else {
        return null;
      }
    },
    getExtension(filename) {
      if (filename == null) {
        var i = filename.lastIndexOf(".");
        return i < 0 ? "" : filename.substr(i).replace(".", "").toLowerCase();
      } else {
        return null;
      }
    },
  },
};
</script>

<style></style>
